/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FormikProps } from 'formik';
import { Campaign } from '../../../../../types/Campaign.type';
import {
  BlogInput,
  MarketingIdeasInput,
  ContentImproverInput,
  EmailInput,
  SocialInput,
  PersonaSocialInput,
  PersonaMarketingIdeasInput,
  PersonaBlogInput,
  PersonaEmailInput,
  PersonaNewsletterInput,
  TikTokCaptionInput,
  BrandMissionInput,
  LinkedInCompanyBioInput,
  ShortVideoScriptInput,
  ValuePropInput,
  YoutubeVideoScriptInput,
} from '../../../../../types/FormTypes';
import { NextImageBasicData } from '../../../../../types/Next';
import { BasicButtonSelectionInput } from '../../../../shared/inputs/BasicButtonSelectionInput';
import { BasicInput } from '../../../../shared/inputs/BasicInput';
import React from 'react';

type IntentInputProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
  defaultOptions?: string[];
  defaultOptionIcons?: NextImageBasicData[];
  title?: string;
  subtitle?: string;
};

export function EmojiSelectionInput<
  T extends
    | BlogInput
    | PersonaBlogInput
    | SocialInput
    | PersonaSocialInput
    | EmailInput
    | PersonaEmailInput
    | PersonaNewsletterInput
    | TikTokCaptionInput
    | BrandMissionInput
    | YoutubeVideoScriptInput
    | ShortVideoScriptInput
    | LinkedInCompanyBioInput
    | ValuePropInput
>({
  formikProps,
  disabled,
  defaultOptions,
  defaultOptionIcons,
  title = 'Include relevant Emojis?',
  subtitle = 'Please select preference.',
}: IntentInputProps<T>) {
  return (
    <BasicButtonSelectionInput
      id="emoji"
      label={
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
      }
      defaultOptions={defaultOptions || []}
      defaultOptionIcons={defaultOptionIcons}
      value={formikProps.values.emoji}
      setValue={formikProps.handleChange('emoji')}
      disabled={disabled}
      errors={formikProps.errors.emoji as string}
      touched={formikProps.touched.emoji ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}

export function HashtagSelectionInput<
  T extends
    | BlogInput
    | PersonaBlogInput
    | SocialInput
    | PersonaSocialInput
    | EmailInput
    | PersonaEmailInput
    | PersonaNewsletterInput
    | TikTokCaptionInput
>({
  formikProps,
  disabled,
  defaultOptions,
  defaultOptionIcons,
  title = 'Include relevant Hashtags?',
  subtitle = 'Please select preference.',
}: IntentInputProps<T>) {
  return (
    <BasicButtonSelectionInput
      id="hashtag"
      label={
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
      }
      defaultOptions={defaultOptions || []}
      defaultOptionIcons={defaultOptionIcons}
      value={formikProps.values.hashtag}
      setValue={formikProps.handleChange('hashtag')}
      disabled={disabled}
      errors={formikProps.errors.hashtag as string}
      touched={formikProps.touched.hashtag ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}
